import type { DeckBackStyle } from '@tarot/contracts';
import { TarotCard } from './TarotCard';

/** Веер из 3 карт — превью колоды в магазине, баннерах и списке колод. */
export function CardFan({ images, back, size = 64 }: { images: (string | null)[]; back?: DeckBackStyle; size?: number }) {
  const cards = images.slice(0, 3);
  return (
    <div className="fan" style={{ width: size * 1.9, height: size * 1.7 }}>
      {cards.map((img, i) => (
        <div key={i} className="fan-card" style={{ width: size, '--i': i - 1 } as React.CSSProperties}>
          <TarotCard card={img ? { key: String(i), name: '', symbol: '', number: 0, keywords: [], imageUrl: img } : null} back={back} flipped={!!img} />
        </div>
      ))}
    </div>
  );
}
